import type { DeepReadonly } from 'vue'

/** When `deckVersion` is 3, redirect to the presentations app (embed or full beta route). */
export function useDeckVersionRedirect(
  deckVersion: DeepReadonly<Ref<number | undefined>>,
  deckId: string | number,
  isEmbed: boolean = false,
) {
  const route = useRoute()

  const checkAndRedirect = () => {
    if (deckVersion.value !== 3) return

    const query = new URLSearchParams(route.query as Record<string, string>).toString()
    const queryString = query ? `?${query}` : ''

    if (isEmbed) {
      window.location.href = `/embed/presentations/${deckId}${queryString}`
    } else {
      window.location.href = `/beta/decks/${deckId}${queryString}`
    }
  }

  return { checkAndRedirect }
}
